import Vue from 'vue'
const vm = new Vue()
const api = {}

// 产品中心列表
api.getProductList = function(id) {
  let url = `/kj-kyc/productEnterprise/listProductInfo?enterpriseId=${id}`
  return vm.$http.get(url)
}
// 判断是否需要进入预填写出口退税
api.isExportRefundOpened = function(id) {
  let url = `/kj-kyc/self/registration/exportRefundRecordTransition?enterpriseId=${id}`
  return vm.$http.get(url)
}
// 发起申请-出口退税产品
api.applyDrawback = function(data) {
  let url = `/kj-kyc/eKyc/activateExportProduct`
  return vm.$http.post(url, data)
}
// 发起申请-出口退税产品-回显已填写的email和phone
api.getEnterpriseManager = function(id) {
  let url = `/kj-kyc/enterpriseContact/getEnterpriseManager?enterpriseId=${id}`
  return vm.$http.get(url)
}
// {enterpriseId, productType} 判断企业是否已建档，并记录产品申请类型
api.isKycProduct = function(data) {
  let url = `/kj-kyc/productEnterprise/isSendWecomWarning`
  return vm.$http.post(url, data)
}
// 校验KYC状态、认证产品状态验证拦截
api.validateProductKyc = function(data) {
  let url = `/kj-kyc/productEnterprise/validateProductKyc`
  return vm.$http.post(url, data)
}
export default api
